module.exports = __webpack_public_path__ + "img/cz.591673ee.svg";